// Iter 317 — Klasifikasi item nota: PRODUKSI vs BIAYA (non-produksi).
//
// Konteks (Live): Beberapa nota menyimpan item "ongkir" / "biaya admin" sebagai
// baris produk di `order.products` (bukan di `form.shipping` numerik). Akibatnya
// item biaya nyasar ke antrean produksi, menuntut mockup, dan menghambat
// penyelesaian tahap. Live tidak memiliki field eksplisit `is_cost`.
//
// Strategi klasifikasi (urutan prioritas):
// 1. Flag eksplisit: `is_cost === true`, `item_type` ∈ {"cost","biaya","ongkir","shipping","fee"},
//    `category === "biaya"`/`"ongkir"`/`"shipping"`.
// 2. Heuristik nama (regex kata utuh): "ongkir", "biaya admin", "biaya kirim",
//    "biaya pengiriman", "pengiriman", "shipping fee", "admin fee", "service fee",
//    "biaya layanan".
// 3. Default: produksi (fail-safe — jangan diam-diam menghilangkan pekerjaan produksi).
//
// Jika ambigu, operator harus memperbaiki klasifikasi lewat Detail Nota.

const COST_FIELD_VALUES = new Set(["cost","biaya","ongkir","shipping","fee","pengiriman"]);
const COST_NAME_RE = /\b(ongkir|biaya[\s_-]*admin|biaya[\s_-]*kirim|biaya[\s_-]*pengiriman|biaya[\s_-]*layanan|pengiriman|shipping[\s_-]*fee|admin[\s_-]*fee|service[\s_-]*fee)\b/i;

export function isCostItem(product) {
  if (!product || typeof product !== "object") return false;
  if (product.is_cost === true || product.production_route === "Non-Produksi") return true;
  const it = String(product.item_type || "").trim().toLowerCase();
  if (it && COST_FIELD_VALUES.has(it)) return true;
  const cat = String(product.category || "").trim().toLowerCase();
  if (cat && COST_FIELD_VALUES.has(cat)) return true;
  const name = `${product.name || ""} ${product.custom_name || ""}`;
  if (COST_NAME_RE.test(name)) return true;
  return false;
}

export function isProductionItem(product) {
  return !isCostItem(product);
}

export function splitByCost(products) {
  const production = [];
  const cost = [];
  for (const p of (products || [])) {
    (isCostItem(p) ? cost : production).push(p);
  }
  return { production, cost };
}

// Offline: cukup 1 mockup per nota — keterangan sumber mockup per produk.
export function mockupSourceLabel(p, noteHasMockup) {
  if (p?.has_mockup && !p?.linked_mockup_valid) return "Mockup sendiri";
  if (p?.linked_mockup_valid || p?.follows_note_mockup) return "Mengikuti mockup utama";
  return noteHasMockup ? "Mengikuti mockup utama" : "Mockup belum diisi (opsional)";
}
